import { space } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.small};
  flex: 1;
  overflow: hidden;
  overflow-x: hidden;
`;
